import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { Spinner } from "./Spinner";

export function ProtectedRoute() {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) return <main className="center-page"><Spinner label="Loading your Bucks account" /></main>;
  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (session.needsGoal && location.pathname !== "/onboarding/goal") return <Navigate to="/onboarding/goal" replace />;
  return <Outlet />;
}
